<div class="public-defect-status" [class.public-defect-status--mobile]="rwdService.isSmallDevice">
  <div class="public-defect-status__card">
    <ng-container *ngIf="!isInvalid; else invalidLink">
      <div class="public-defect-status__hero">
        <div class="public-defect-status__hero-icon">
          <mat-icon>{{ isLoading ? 'hourglass_top' : 'fact_check' }}</mat-icon>
        </div>
        <div class="public-defect-status__hero-content">
          <div class="public-defect-status__hero-head">
            <h1>{{ 'estate.qrStatusTitle' | loc }}</h1>
            <app-language-select></app-language-select>
          </div>
          <p>{{ 'estate.qrStatusDesc' | loc }}</p>
        </div>
      </div>

      <div class="public-defect-status__loading" *ngIf="isLoading; else statusContent">
        <mat-spinner diameter="44"></mat-spinner>
        <div>
          <div class="public-defect-status__loading-title">{{ 'estate.qrStatusLoadingTitle' | loc }}</div>
          <p>{{ 'estate.qrStatusLoadingDesc' | loc }}</p>
        </div>
      </div>

      <ng-template #statusContent>
        <div class="public-defect-status__panel" *ngIf="statusData">
          <div class="public-defect-status__panel-head">
            <div>
              <div class="public-defect-status__panel-label">{{ 'estate.qrStatusRequestId' | loc }}</div>
              <div class="public-defect-status__panel-value">{{ requestLabel }}</div>
            </div>
            <div class="public-defect-status__badge" [ngClass]="statusClass">{{ statusKey | loc }}</div>
          </div>

          <div class="public-defect-status__title">{{ statusData.title }}</div>

          <div class="public-defect-status__meta">
            <div class="public-defect-status__meta-item">
              <span>{{ 'estate.qrStatusCreatedAt' | loc }}</span>
              <strong>{{ statusData.createdAt | lDate: 'dtShort' }}</strong>
            </div>
            <div class="public-defect-status__meta-item">
              <span>{{ 'estate.qrStatusUpdatedAt' | loc }}</span>
              <strong *ngIf="statusData.statusChangedAt; else noStatusUpdate">
                {{ statusData.statusChangedAt | lDate: 'dtShort' }}
              </strong>
              <ng-template #noStatusUpdate>
                <strong>{{ 'estate.qrStatusNoUpdate' | loc }}</strong>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="public-defect-status__property" *ngIf="propertyDetailsSummary">
          <div class="public-defect-status__property-label">{{ 'estate.qrPublicPropertyData' | loc }}</div>
          <p class="public-defect-status__property-text">{{ propertyDetailsSummary }}</p>
        </div>
      </ng-template>
    </ng-container>

    <ng-template #invalidLink>
      <div class="public-defect-status__hero public-defect-status__hero--invalid">
        <div class="public-defect-status__hero-icon public-defect-status__hero-icon--invalid">
          <mat-icon>error_outline</mat-icon>
        </div>
        <div class="public-defect-status__hero-content">
          <div class="public-defect-status__hero-head">
            <h1>{{ 'estate.qrStatusInvalidTitle' | loc }}</h1>
            <app-language-select></app-language-select>
          </div>
          <p>{{ 'estate.qrStatusInvalidDesc' | loc }}</p>
        </div>
      </div>
    </ng-template>

    <div class="public-defect-status__footer">
      <div class="public-defect-status__brand" aria-hidden="true">
        <app-logo-svg color="primary"></app-logo-svg>
      </div>
      <div class="public-defect-status__footer-text">
        {{ 'estate.qrFooterGeneratedWith' | loc }}
        <a href="https://fliko.pl/" target="_blank" rel="noopener noreferrer">Fliko</a>
      </div>
    </div>
  </div>
</div>
